import { Routes } from '@angular/router';
import { AuthGuard as FireAuthGuard, redirectUnauthorizedTo } from '@angular/fire/auth-guard';
import { USERS_ROUTES } from './modules/users/users.routes';
import { AUTH_ROUTES } from './auth/auth.routes';
import { COMPANIES_ROUTES } from './modules/companies/companies.routes';
import { JOBS_ROUTES } from './modules/jobs/jobs.routes';
import { COMPANY_INSIGHTS_ROUTES } from './modules/company-insights';
import { EMPLOYEES_ROUTES } from './modules/employees';
import { CANDIDATES_POOL_ROUTES } from './modules/candidates-pool/candidates-pool.router';
import { EXAMPLES_ROUTES } from './modules/examples/examples.routes';
import { PROCUREMENT_ROUTES } from './modules/procurement/procurement.routes';
import { CHATBOT_ROUTES } from './modules/chatbot/chatbot.routes';
import { WORK_FLOWS_ROUTES } from './modules/workflows/workflows.routes';
import { RECRUITERS_ROUTES } from './modules/recruiters/recruiters.routes';
import { RECRUITER_DASHBOARD_ROUTES } from './modules/recruiter-dashboard/recruiter-dashboard.routes';

const redirectUnauthorizedToLogin = () => redirectUnauthorizedTo(["auth"]);

export const APP_ROUTES: Routes = [
    ...AUTH_ROUTES,
    ...EXAMPLES_ROUTES,
    {
        path: '',
        canActivate: [FireAuthGuard],
        data: { authGuardPipe: redirectUnauthorizedToLogin },
        loadComponent: () => import('./app-layout/app-layout.component').then((e) => e.AppLayoutComponent),
        children: [
            ...COMPANY_INSIGHTS_ROUTES,
            ...RECRUITER_DASHBOARD_ROUTES,
            ...USERS_ROUTES,
            ...COMPANIES_ROUTES,
            ...EMPLOYEES_ROUTES,
            ...JOBS_ROUTES,
            ...RECRUITERS_ROUTES,
            ...CANDIDATES_POOL_ROUTES,
            ...PROCUREMENT_ROUTES,
            ...CHATBOT_ROUTES,
            ...WORK_FLOWS_ROUTES,
            {
                path: '',
                redirectTo: 'dashboard',
                pathMatch: 'full',
            },
        ]
    },
    {
        path: '**',
        redirectTo: 'auth',
    },
];
